<template>
    <div class="hold-transition sidebar-mini layout-fixed">
      <div class="wrapper">
        <HeaderContent v-if="showLayout"/>
        <SidebarContent v-if="showLayout"/>
        
        <div class="content-wrapper" v-if="showLayout">
          <div class="content">
            <div class="container-fluid">
              <router-view />
            </div>
          </div>
        </div>
        
        <div v-else>
          <!-- Solo login u otras páginas sin layout -->
          <router-view />
        </div>
        
        <FooterContent v-if="showLayout"/>
        <InactividadClose />
      </div>
    </div>
  </template>
  
  <script>
  import HeaderContent from './adminlte/HeaderContent.vue'
  import SidebarContent from './adminlte/SidebarContent.vue'
  import FooterContent from './adminlte/FooterContent.vue'
  
  export default {
    name: 'App',
    components: { HeaderContent, SidebarContent, FooterContent },
    
    computed: {
      showLayout() {
        const noLayoutRoutes = ["/login"]
        return !noLayoutRoutes.includes(this.$route.path)
      }
    },
  
    data() {
      return {
        usuarioAuth: !!localStorage.getItem('access'),
        sesionInterval: null,
      }
    },
  
    methods: {
      async verificarSesion() {
        const token = localStorage.getItem("access");
        if (!token) return false;

        this.$axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        try {
            await this.$axios.get("api/auth/verificar_token/");
            return true;
        } catch (error) {
            console.error("Error en verificarSesion:", error.response?.data || error.message);

            // Si devuelve 401 o token inválido
            if (error.response?.status === 401) {
            const refresh = localStorage.getItem("refresh");
            if (!refresh) {
                this.logout();
                return false;
            }

            try {
                const resp = await this.$axios.post("api/auth/token/refresh/", { refresh });
                localStorage.setItem("access", resp.data.access);
                this.$axios.defaults.headers.common['Authorization'] = `Bearer ${resp.data.access}`;
                return true;
            } catch (e) {
                console.error("Refresh token inválido o expirado:", e.response?.data || e);
                this.logout();
                return false;
            }
            }

            this.logout();
            return false;
        }
      },
  
      logout() {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        this.$router.push("/login");
      }
    },
  
    async created() {
        // Si el access o refresh están vencidos, se eliminan
        try {
        const access = localStorage.getItem("access");
        const refresh = localStorage.getItem("refresh");

        // Decodificar sin verificar firma para ver expiración
        const parseJwt = (token) => {
            try {
            return JSON.parse(atob(token.split('.')[1]));
            } catch (e) {
            return null;
            }
        };

        const now = Math.floor(Date.now() / 1000);

        const accessData = access ? parseJwt(access) : null;
        const refreshData = refresh ? parseJwt(refresh) : null;

        if (!accessData || accessData.exp < now || !refreshData || refreshData.exp < now) {
            console.warn("Token expirado detectado, limpiando sesión...");
            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
            this.$router.push("/login");
            return;
        }
        } catch (e) {
        console.error("Error al verificar tokens locales", e);
        this.logout();
        }
    },
  
    mounted() {
        const token = localStorage.getItem("access");
        if (token) {
            this.$axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            this.verificarSesion().then((sesionActiva) => {
            if (!sesionActiva) {
                this.$router.push("/login");
            } else if (this.$route.path === "/login") {
                this.$router.push("/dashboard");
            }
            });
        } else {
            this.$router.push("/login");
        }

      // 🔥 Interceptor global de respuestas para refrescar el token con cada interaccion
        this.$axios.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error.response && error.response.status === 401) {
                const refresh = localStorage.getItem("refresh");
                if (refresh) {
                    try {
                    const resp = await this.$axios.post("api/auth/token/refresh/", { refresh });
                    localStorage.setItem("access", resp.data.access);
                    this.$axios.defaults.headers.common['Authorization'] = `Bearer ${resp.data.access}`;
                    error.config.headers['Authorization'] = `Bearer ${resp.data.access}`;
                    return this.$axios(error.config);
                    } catch (e) {
                    console.error("Refresh token inválido, cerrando sesión");
                    this.logout();
                    }
                } else {
                    this.logout();
                }
                }
                // 🔥 importante: siempre rechazar al final
                return Promise.reject(error);
            }
        );
    },
  
    beforeUnmount() {
      clearInterval(this.sesionInterval);
    }
  }
  </script>
  